export default __webpack_public_path__ + "21e8ae5b97571a73d7e690d266c6459f.svg";